import type { FxEvent } from './types'

const hash01 = (n: number): number => { const s = Math.sin(n * 127.1 + 311.7) * 43758.5453; return s - Math.floor(s) }

/** Floor spray at the lowest sweep-tip position (or directly below it). */
export function drawKnightSweepScrape(ctx: CanvasRenderingContext2D,
  f: Extract<FxEvent, { kind: 'knight_sweep_scrape' }>, age: number): void {
  if (age < 0 || age > 0.5) return
  const seed = f.x * 0.37 + f.t * 91.7
  const fade = (1 - age / 0.5) ** 2
  ctx.save()
  for (let i = 0; i < 72; i++) {
    const h = hash01(seed + i * 3.7), h2 = hash01(seed + i * 5.9 + 17)
    const h3 = hash01(seed + i * 11.3 + 41)
    const vx = 70 + 240 * h, vy = 45 + 180 * h2
    const x = f.x + f.dir * (vx * age + (h3 - 0.5) * 22)
    const y = Math.min(f.y - 1, f.y - 2 - vy * age + 660 * age * age)
    const size = 1 + 3 * h3
    ctx.fillStyle = `rgba(${92 + Math.round(h * 38)},${97 + Math.round(h * 33)},${111 + Math.round(h * 35)},${(0.78 * fade).toFixed(3)})`
    // Fine short streaks, each at most 4 px wide; no filled ellipse/cloud shapes.
    ctx.fillRect(x - size / 2, y - size / 2, size, Math.max(1, size * 0.55))
  }
  ctx.restore()
}
